export const environment = {
  production: true,
  apiUrl: "https://api-clone.alaga.ph/",
  watermark: '',
  watermarkMode: 'center', // 'repeat' or 'center'
  watermarkOpacity: 0.05,
  watermarkSize: '2.5rem',
  watermarkGap: 80,
  PWD_ID_FRONT : 25,
  PWD_ID_BACK : 28,
  SP_ID: 29 
};

console.log = () => {};
console.error = () => {};
console.warn = () => {};
